import { createFourierModel } from "./model";
import { penguin } from "./shapes/penguin";

export const penguinModel = createFourierModel(penguin);
